import { col, type Shape } from './base.ts';

export const TICKET_REGISTRY: Shape = [
  col('ticketId', 'unitless', 'Unique ticket identifier.'),
  col('ticketSummary', 'unitless', 'Brief summary of the issue or action item.'),
  col('status', 'unitless', 'Current ticket status: OPEN, IN_PROGRESS, CLOSED, CANCELLED.'),
  col('priority', 'unitless', 'Ticket priority level: LOW, MEDIUM, HIGH, URGENT.'),
  col('reportedDate', 'unitless', 'Date/time the ticket was created or reported.'),
  col('dueDate', 'unitless', 'Target date for ticket resolution.'),
  col('closedDate', 'unitless', 'Date/time the ticket was closed.'),
  col('assignedTo', 'unitless', 'Person or team assigned to resolve the ticket.'),
  col('description', 'unitless', 'Full description of the issue, including context and observations.'),
  col('recommendation', 'unitless', 'Recommended action or investigation steps to resolve the issue.'),
  col('actionPlan', 'unitless', 'Detailed action plan with steps to remediate the issue.'),
  col('ticketCategory', 'unitless', 'Category classification (e.g., WELL_ISSUE, ESP_FAILURE, OPTIMIZATION).'),
  col('ticketSource', 'unitless', 'Origin of the ticket (e.g., ALARM, MANUAL, SURVEILLANCE, WORKFLOW).'),
  col('entityType', 'unitless', 'Type of entity the ticket relates to: WELL, STRING, FIELD, RESERVOIR.'),
  col(
    'entityName',
    'unitless',
    'Name of the well, string, or field the ticket is associated with (scalar string, not a relation).',
  ),
  col(
    'isOpportunity',
    'unitless',
    "Whether the ticket is a production-optimization opportunity ('true'/'false' string flag).",
  ),
];
